import styled from 'styled-components';
import UIFlex from 'UIComponents/layout/UIFlex';
import { stringToId } from 'developer-docs-shared-components/utils/urls';
import { introductionId, useCasesId } from '../constants';
import { getBadgeColorByMethodName } from 'developer-docs-shared-components/config/methods';
import I18n from 'I18n';
import { Text } from 'foundations-components/components/Text';
import { Badge } from 'foundations-components/transitional/components/Badge';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const DocTitle = styled.span.withConfig({
  displayName: "util__DocTitle",
  componentId: "k3cqh3-0"
})(["word-break:break-word;"]);
const makeTocLabel = doc => {
  return /*#__PURE__*/_jsxs(UIFlex, {
    justify: "between",
    align: "start",
    children: [/*#__PURE__*/_jsx(Text, {
      as: "span",
      color: "fill-surface-recessed",
      typography: "body-100",
      children: doc.title
    }), /*#__PURE__*/_jsx(Badge, {
      use: getBadgeColorByMethodName(doc.api.method),
      marginInlineStart: "300",
      children: doc.api.method === 'delete' ? 'DEL' : doc.api.method.toUpperCase()
    })]
  });
};
export const populateToc = oasDocs => {
  const tocs = [{
    depth: 0,
    id: introductionId,
    label: 'Introduction',
    parent: null
  }, {
    depth: 0,
    id: useCasesId,
    label: 'Use cases for this API',
    parent: null
  }];

  // The "slug" value will be the name of the tag for an endpoint if it has one.
  const hasGroupTags = oasDocs[0].slug !== oasDocs[0].swagger.path;
  if (hasGroupTags) {
    const slugs = [...new Set(oasDocs.map(doc => doc.slug))];
    slugs.forEach(slug => {
      const docs = oasDocs.filter(doc => {
        return doc.slug === slug;
      });
      const parent = stringToId(slug);
      tocs.push({
        depth: 0,
        id: parent,
        label: slug,
        parent: null
      });
      docs.forEach(doc => {
        tocs.push({
          depth: 1,
          id: stringToId(`${doc.api.method}-${doc.swagger.path}`),
          label: makeTocLabel(doc),
          parent
        });
      });
    });
  } else {
    oasDocs.forEach(doc => {
      tocs.push({
        depth: 0,
        id: stringToId(`${doc.api.method}-${doc.swagger.path}`),
        label: makeTocLabel(doc),
        parent: null
      });
    });
  }
  return tocs;
};
export const populateLegacyToc = (name, orderedTitles, orderedHttpMethods, hasIntroAndUseCase) => {
  const tocs = [];
  if (hasIntroAndUseCase) {
    tocs.push({
      depth: 0,
      id: introductionId,
      label: I18n.text('developer-docs-ui.apiReference.introductionTitle'),
      parent: null
    });
    tocs.push({
      depth: 0,
      id: useCasesId,
      label: I18n.text('developer-docs-ui.apiReference.useCasesTitle'),
      parent: null
    });
  }
  orderedTitles === null || orderedTitles === void 0 || orderedTitles.forEach((title, index) => {
    tocs.push({
      depth: 1,
      id: stringToId(title),
      label: /*#__PURE__*/_jsxs(UIFlex, {
        justify: "between",
        align: "center",
        children: [/*#__PURE__*/_jsx(DocTitle, {
          children: title
        }), (orderedHttpMethods === null || orderedHttpMethods === void 0 ? void 0 : orderedHttpMethods[index]) && /*#__PURE__*/_jsx(Badge, {
          use: getBadgeColorByMethodName(orderedHttpMethods[index].toLowerCase()),
          marginInlineStart: "300",
          children: orderedHttpMethods[index].toLowerCase() === 'delete' ? 'DEL' : orderedHttpMethods[index].toUpperCase()
        })]
      }),
      parent: null
    });
  });
  return tocs;
};
const hubToHubName = {
  marketing: 'marketing_hub',
  sales: 'sales_hub',
  service: 'service_hub',
  cms: 'cms'
};
const tierToTierName = {
  STARTER: 'starter',
  PROFESSIONAL: 'professional',
  ENTERPRISE: 'enterprise',
  FREE: 'free'
};
const productAndTierToName = (hub, tier) => {
  return `${hubToHubName[hub]}-${tierToTierName[tier]}`;
};
export const publicApiSpecProductTierRequirementsToProductTierProps = publicApiSpecProductTierRequirements => {
  return Object.keys(publicApiSpecProductTierRequirements).reduce((array, key) => {
    const hubKey = key;
    const productTier = publicApiSpecProductTierRequirements[hubKey];
    const propName = productTier && productAndTierToName(hubKey, productTier);
    if (propName) {
      array.push(propName);
    }
    return array;
  }, []);
};